export const setId = (id) => ({
    type: 'SET_ID',
    payload: id,
});
